export function initChristmasMarketOfferVatId(root = document) {
  const countryInput = root.querySelector('[name="christmas_market_offer[country]"]')
  const vatIdInput = root.querySelector('[name="christmas_market_offer[vat_id]"]')
  if (!countryInput || !vatIdInput) return

  const label = root.querySelector(`label[for="${vatIdInput.id}"]`)
  const requiredCountries = (vatIdInput.dataset.requiredCountries || '').split(',')
  const updateRequirement = () => {
    const required = requiredCountries.includes(countryInput.value)
    vatIdInput.required = required
    vatIdInput.setAttribute('aria-required', String(required))
    if (label) label.textContent = required ? label.dataset.requiredLabel : label.dataset.optionalLabel
  }

  countryInput.addEventListener('change', updateRequirement)
  updateRequirement()
}
